import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import I18n from 'i18n-react'

// components
import TextInput from '../Components/_ui/TextInput.js'

// redux
import DomexActions from '../Redux/DomexRedux'
import GeneralActions from '../Redux/GeneralRedux'
import { SCREENS } from '../Redux/NavigationRedux'

class CustomerFormContainer extends React.Component {
	static propTypes = {
		city: PropTypes.string.isRequired,
		domexChangeCity: PropTypes.func.isRequired,
		domexChangeHouseNo: PropTypes.func.isRequired,
		domexChangePhone: PropTypes.func.isRequired,
		domexChangeStreet: PropTypes.func.isRequired,
		domexChangeSurname: PropTypes.func.isRequired,
		domexChangeZipCode: PropTypes.func.isRequired,
		domexValidationErrorCustomerFormChange: PropTypes.func.isRequired,
		houseNo: PropTypes.string.isRequired,
		onSetScreenIsValid: PropTypes.func.isRequired,
		phone: PropTypes.string.isRequired,
		screenValidateSig: PropTypes.array.isRequired,
		street: PropTypes.string.isRequired,
		surname: PropTypes.string.isRequired,
		validationErrorsCustomerForm: PropTypes.object.isRequired,
		zipCode: PropTypes.string.isRequired,
	}

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.screenValidateSig[SCREENS.CUSTOMER_FORM].validate === true) {
			const valid = this.handleValidate()
			nextProps.onSetScreenIsValid(SCREENS.CUSTOMER_FORM, valid)
		}
	}

	handleChangeCity = (city) => {
		this.props.domexChangeCity(city)
	}

	handleChangeHouseNo = (houseNo) => {
		this.props.domexChangeHouseNo(houseNo)
	}

	handleChangePhone = (phone) => {
		localStorage.setItem('phone', phone)
		this.props.domexChangePhone(phone)
	}

	handleChangeStreet = (street) => {
		this.props.domexChangeStreet(street)
	}

	handleChangeSurname = (surname) => {
		this.props.domexChangeSurname(surname)
	}

	handleChangeZipCode = (zipCode) => {
		this.props.domexChangeZipCode(zipCode)
	}

	handleOnErrorChange = (name, error) => {
		this.props.domexValidationErrorCustomerFormChange(name, error, SCREENS.CUSTOMER_FORM)
	}

	handleValidate = () => this.streetInput.validate() && this.houseNoInput.validate() &&
		this.zipCodeInput.validate() && this.cityInput.validate() && this.phoneInput.validate() &&
		this.surnameInput.validate()

	render() {
		return (
			<div>
				<h3>{I18n.translate('general.customerFormTitle')}</h3>
				<TextInput
					isRequired
					isStreet
					label={I18n.translate('general.street')}
					name='street'
					onChange={this.handleChangeStreet}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.streetInput = ref
					}}
					validationErrors={this.props.validationErrorsCustomerForm}
					value={this.props.street}
				/>
				<TextInput
					isLandRegistryNumber
					isRequired
					label={I18n.translate('general.houseNo')}
					name='houseNo'
					onChange={this.handleChangeHouseNo}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.houseNoInput = ref
					}}
					validationErrors={this.props.validationErrorsCustomerForm}
					value={this.props.houseNo}
				/>
				<TextInput
					isRequired
					isZipCode
					label={I18n.translate('general.zipCode')}
					name='zipCode'
					onChange={this.handleChangeZipCode}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.zipCodeInput = ref
					}}
					type='number'
					validationErrors={this.props.validationErrorsCustomerForm}
					value={this.props.zipCode}
				/>
				<TextInput
					isCity
					isRequired
					label={I18n.translate('general.city')}
					name='city'
					onChange={this.handleChangeCity}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.cityInput = ref
					}}
					validationErrors={this.props.validationErrorsCustomerForm}
					value={this.props.city}
				/>
				<h3>{I18n.translate('general.customerFormContactTitle')}</h3>
				<TextInput
					isPhone
					isRequired
					label={I18n.translate('general.phone')}
					name='phone'
					onChange={this.handleChangePhone}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.phoneInput = ref
					}}
					type='tel'
					validationErrors={this.props.validationErrorsCustomerForm}
					value={this.props.phone}
				/>
				<TextInput
					isRequired
					isSurname
					label={I18n.translate('general.surname')}
					name='surname'
					onChange={this.handleChangeSurname}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.surnameInput = ref
					}}
					validationErrors={this.props.validationErrorsCustomerForm}
					value={this.props.surname}
				/>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	street: state.domex.street,
	houseNo: state.domex.houseNo,
	zipCode: state.domex.zipCode,
	city: state.domex.city,
	phone: state.domex.phone,
	surname: state.domex.surname,
	validationErrorsCustomerForm: state.domex.validationErrorsCustomerForm,
	screenValidateSig: state.general.screenValidateSig,
})

const mapDispatchToProps = {
	domexChangeCity: DomexActions.domexChangeCity,
	domexChangeHouseNo: DomexActions.domexChangeHouseNo,
	domexChangePhone: DomexActions.domexChangePhone,
	domexChangeStreet: DomexActions.domexChangeStreet,
	domexChangeSurname: DomexActions.domexChangeSurname,
	domexChangeZipCode: DomexActions.domexChangeZipCode,
	domexValidationErrorCustomerFormChange: DomexActions.domexValidationErrorCustomerFormChange,
	onSetScreenIsValid: GeneralActions.onSetScreenIsValid,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerFormContainer)
